<template>
  <div class="infotype-checkbox">
    <MyCheckbox
      :data="data"
      :value="data.fieldvalue || []"
      class="info-type"
      @change="handleChange($event, 'info_type')"
    />
    <MyCheckbox
      :data="infoSign"
      :value="infoSign.fieldvalue || []"
      class="info-sign"
      @change="handleChange($event, 'info_sign')"
    />
  </div>
</template>

<script>
import MyCheckbox from './Checkbox'
export default {
  components: {
    MyCheckbox
  },
  props: {
    'data': {
      type: [Object, Array, String, Boolean],
      default: () => ({})
    }
  },

  computed: {
    infoSign () {
      const { fieldconfig = {} } = this.data || {}
      const { info_sign: infoSign = {} } = fieldconfig
      infoSign.fieldname = ''
      return infoSign
    }
  },
  methods: {
    handleChange (val, type) {
      if (type === 'info_type') {
        this.data.fieldvalue = val
      } else if (type === 'info_sign' && this.data.fieldconfig && this.data.fieldconfig.info_sign) {
        this.data.fieldconfig.info_sign.fieldvalue = val
      }

      this.$emit('change', this.data.fieldvalue || [], this.data)
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped lang="scss">
.info-type {
  border-bottom: solid 1px #dbdbdb;
}
</style>
